<template>
  <div>
    <Banner :classType="1" />
    <Menu v-if="lang=='cn'"/>
    <Menu2 v-else/>
    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>荣誉信誉</h2>
      <p>HONORS</p>
    </div>
    <div class="wow animate__slideInUp">
      <div class="history about-timeline">
        <div class="wrap flex">
          <div class="sidebar" :class="{ s1: lang == 'en' }">
            <div class="about-timeline-year">
              <div id="wrapper">
                <div
                  class="dd"
                  :key="idx"
                  :class="{ active: idx == 0 }"
                  v-for="(item, idx) in list"
                >
                  {{ item.Name }}
                </div>
              </div>
            </div>
          </div>

          <div class="content year-content">
            <ul>
              <li
                v-for="(item, idx) in list"
                :key="idx"
                :class="{ active: idx == 0 }"
              >
                <h4>{{ item.Name }}</h4>
                <div class="overtext">
                  <div
                    class="dd cont1"
                    :key="subIdx"
                    v-for="(subItem, subIdx) in item.AwardsInfos.slice(0, 3)"
                  >
                    <div class="item flex-cb">
                      <div class="item_left">
                        <div class="tit">{{ subItem.Date }}</div>
                        <div class="desc">{{ subItem.Name }}</div>
                      </div>
                      <div
                        class="item_link"
                        @click="showImg(true, subItem.Url)"
                      >
                        <span v-if="lang == 'zh'">查看奖状</span>
                        <span v-else>Certificate</span>
                      </div>
                    </div>
                  </div>
                  <div class="cont2">
                    <div
                      class="dd"
                      :key="subIdx"
                      v-for="(subItem, subIdx) in item.AwardsInfos"
                    >
                      <div class="item flex-cb">
                        <div class="item_left">
                          <div class="tit">{{ subItem.Date }}</div>
                          <div class="desc">{{ subItem.Name }}</div>
                        </div>
                        <div
                          class="item_link"
                          @click="showImg(true, subItem.Url)"
                        >
                          <span v-if="lang == 'zh'">查看奖状</span>
                          <span v-else>Certificate</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a
                  href="javascript:;"
                  class="btn-loadmore"
                  v-if="item.AwardsInfos.length > 3"
                  ><span>展开更多</span> <i class="el-icon-arrow-down"></i
                ></a>
                <a
                  href="javascript:;"
                  class="btn-loadmore active"
                  style="display: none"
                  v-if="item.AwardsInfos.length > 3"
                  ><span>收起</span> <i class="el-icon-arrow-up"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="imgMask" v-if="showHonor" @click="showImg(false)">
      <div class="imgBig">
        <div class="imgBbox">
          <el-image class="imgIner" :src="imgUrl" fit="contain"></el-image>
          <i class="el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { judgeWindow } from "@/utils/tool.js";
import Banner from "@/views/components/Banner";
import Menu from "./Menu.vue";
import Menu2 from "./Menu2.vue";
import { WOW } from "wowjs";
import { changeText } from "@/utils/tool";

export default {
  data() {
    return {
      type: this.$route.query.type || "",
      lang: this.$global.lang,
      showHonor: false,
      num: 0,
      item_name: "国家级荣誉",
      en_name: "National Honors",
      newsNav: [
        { honorNum: 3, honorIntro: "国家级荣誉" },
        { honorNum: 13, honorIntro: "协会荣誉" },
        { honorNum: 5, honorIntro: "省级荣誉" },
        { honorNum: 4, honorIntro: "市级荣誉" },
      ],
      newsOn: 0,
      list: [],
      AwardsInfos: [],
      moment: this.$moment,
      contactList: [],
      imgUrl: "",
      showHonor: false,
      showSwiper: false,
      showENO: true,
      showENC: true,
      showAll: false, // 控制展开和收起的标志
      swiperOption: {
        slidesPerView: 1,
        noSwiping: true,
      },
    };
  },
  components: {
    Banner,
    Menu,
    Menu2
  },

  mounted() {
    // 发展历程
    var $yearContent = $(".year-content");
    var height = $(".year-content ul li.active").height();
    $(".year-content").height(height, "2222");
    $(document).on("click", ".about-timeline-year .dd", function () {
      console.log("222");
      $(".year-content").removeAttr("style");
      $(".year-content .overtext").removeClass("active");
      $(".year-content .btn-loadmore").show();
      $(".year-content .btn-loadmore.active").hide();
      $(this).addClass("active").siblings().removeClass("active");
      $yearContent
        .find("li")
        .eq($(this).index())
        .addClass("active")
        .siblings()
        .removeClass("active");
      var num = 0;
      num = parseInt(
        $yearContent.find("li").eq($(this).index()).position().top,
        10
      );
      var height2 = $(".year-content ul li.active").outerHeight();
      $(".year-content").height(height2);
      console.log(height2, "+++++++++3333");
      var _winw = $(window).width();
      if (_winw >= 981) {
        $yearContent.animate(
        {
          
          scrollTop: num + $yearContent.scrollTop() - 150,
        },
        400
      );
      } else {
        $yearContent.animate(
        {
          
          scrollTop: num + $yearContent.scrollTop() - 80,
        },
        400
      );
  }
      
      $("html,body").animate(
        {
          scrollTop:
            $(".about-timeline").offset().top - $(".el-header").outerHeight(),
        },
        400
      );
    });

    // 展开点击
    $(document).on("click", ".year-content .btn-loadmore", function () {
      if ($(this).hasClass("active")) {
        $(".year-content").removeAttr("style");
        $(this).parent().find(".btn-loadmore").show();
        $(this).hide();
        $(this)
          .parent()
          .find(".overtext")
          .removeClass("active")
          .removeClass("no-masking");
      } else {
        $(this)
          .parent()
          .find(".overtext")
          .addClass("active")
          .addClass("no-masking");
        $(this).hide();
        $(this).parent().find(".btn-loadmore.active").show();
      }
      var height3 = $(".year-content ul li.active").outerHeight();
      $(".year-content").height(height3);
      console.log(height3, "+++++++++4444");
    });

    this.type = this.$route.params.type;
    this.changeShow();

    this.$api.honor().then((res) => {
      const { Honors } = res.Value;
      this.list = Honors;
      this.AwardsInfos = this.list[0].AwardsInfos;
    });

    this.$api
      .contact({
        Type: 1,
      })
      .then((res) => {
        const { CompanyInfos } = res.Value;
        this.contactList = CompanyInfos;

        // this.initSwip();

        new WOW({
          boxClass: "wow",
          animateClass: "animate__animated",
          live: false,
        }).init();

        if (this.type == "contact") {
          this.handleScroll2();
        }
      });
    this.changeW();
  },
  methods: {
    changeShow() {
      if (this.lang == "en") {
        if (this.type == "honor") {
          this.showENC = false;
          this.showENO = true;
        }
        if (this.type == "contact") {
          this.showENO = false;
          this.showENC = true;
        }
      }
    },
    changeValue(value) {
      return changeText(value);
    },

    showImg(show, url) {
      this.imgUrl = url;
      this.showHonor = show;
    },
    changeW() {
      if (judgeWindow()) {
        this.num = 1;
      } else {
        this.num = 3;
      }
    },

    toggleLoadMore() {
      this.showAll = !this.showAll; // 切换展开和收起的状态
      this.$emit("showAll", true);
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "contact") {
          this.handleScroll2();
        }
        this.changeShow();
      }
    );
  },
};
</script>
<style scoped lang="scss">
.history .sidebar {
  width: 23%;
  &.s1 {
    width: 35%;
  }
}
.content {
  overflow: hidden;
  padding: 30px 0;
  .slides {
    width: 100%;
  }
}
.history .swiper-slide {
  background: none;
  text-align: left;
  width: 100%;
  height: auto !important;
  display: block;
}
.slides .swiper-slide:hover {
  -webkit-transform: scale(1);
  transform: scale(1);
}

.history .year-content {
  // padding: 0 0 130px 0;
  height: 380px;
  overflow: hidden;
  margin: 0;
  padding: 0 !important;

  ul {
    max-width: 680px;
    overflow: hidden;
    padding-right: 0;
    li {
      padding-bottom: 0;
      padding-top: 25px;
      opacity: 0.1;
      width: auto;
      display: block;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
      width: 100%;
      .overtext {
        line-height: 1.6;
        // height: 500px;
        overflow: hidden;
        position: relative;
        &::before {
          content: "";
          left: 0;
          height: 80px;
          width: 100%;
          position: absolute;
          bottom: 0;
          background: linear-gradient(
            rgba(245, 245, 245, 0) 0%,
            rgba(245, 245, 245, 1) 90%
          );
          z-index: 9;
        }
        .cont2 {
          display: none;
        }
        &.active {
          .cont1 {
            display: none;
          }
          .cont2 {
            display: block;
          }
        }
      }

      .dd {
        margin-bottom: 15px;
      }
      .tit1 {
        padding: 5px 0;
        font-size: 20px;
        font-weight: bold;
      }
      .tit2 {
        padding: 6px 0 20px 0;
      }
      h4 {
        font-size: 36px;
        color: #5a5858;
        margin-bottom: 25px;
        text-align: left;
      }

      &.active {
        opacity: 1;
        .overtext::before {
          display: none;
        }
      }
      &:nth-child(1) {
        margin-bottom: 30px;
      }
    }
  }
}

@media (max-width: 768px) {
  .history .wrap {
    &::before{
      display:none;
    }
    .sidebar {
      margin-bottom:15px!important;
      #wrapper {
        display: flex;
        justify-content: space-between;
      }
      .dd {
        padding-left: 8px !important;
        padding-bottom:10px;
        font-size:18px;
        &::before{
          width:90%;
          height:3px;
          position: absolute;
          bottom:0;
          left:50%;
          transform: translateX(-50%);
          top:auto;
          opacity:0;
        }
        &.active{
          &::before{
            opacity:1;
          }
        }
      }
    }
  }
  .history .year-content ul li{
    margin-bottom:0!important;
    .overtext{
      line-height: normal;
    }
    .item_left .desc{
      font-size:14px;
    }
    h4{
      font-size:24px;
    }
    .btn-loadmore{
      margin-top:0;
    }
    .item_link{
      width:4.2rem;
      height:2rem;
      font-size:13px
    }
  }
}

.item_name {
  font-size: 2rem;
  padding-bottom: 2rem;
}
.history .year-content {
  margin: 0;
  li {
    .item_left {
      .tit {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        font-size: 16px;
        line-height: 1.3;
        margin-top: 0.5rem;
      }
    }
    .item_link {
      width: 6.5rem;
      cursor: pointer;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #9b9b9b;
      border-radius: 2rem;
      &:hover {
        background: #c6322d;
        color: #fff;
        border-color: #c6322d;
      }
    }
  }
}

@media (max-width: 768px) {
  .slides li {
    margin: 1.5rem 0;
  }
  .history .wrap {
    flex-direction: column;
    .sidebar {
      width: 100%;
      margin-bottom: 2rem;
    }
  }

  .honorTimeB {
    padding-left: 1rem;
  }
  .item_name {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
  .slides li .item_link {
    width: 5rem;
    height: 2rem;
  }
  .history .year-content{
    height:300px;
  }
}

</style>
